import constants from '../constants';

export const showDashboard = () => ({
  type: constants.SHOW_DASHBOARD,
});

export const hideDashboard = () => ({
  type: constants.HIDE_DASHBOARD,
});
